export function readIsolatedRows(io) {
  const listed = io?.list?.();
  const rows = Array.isArray(listed) ? listed : [];
  const out = [];
  for (const row of rows) {
    const slot = String(row?.slot || "").trim();
    if (!slot) continue;
    try {
      const value = JSON.parse(String(row?.value || ""));
      if (value && typeof value === "object" && !Array.isArray(value)) {
        out.push({ slot, value });
      }
    } catch {
      // A corrupt item is isolated to its own slot and cannot blank the domain.
    }
  }
  return out;
}

export function writeIsolatedRow(io, slot, value) {
  const normalizedSlot = String(slot || "").trim();
  if (
    !normalizedSlot ||
    !value ||
    typeof value !== "object" ||
    Array.isArray(value)
  ) {
    return false;
  }
  io.write(normalizedSlot, JSON.stringify(value));
  return true;
}

export function removeIsolatedRow(io, slot) {
  const normalizedSlot = String(slot || "").trim();
  if (!normalizedSlot) return false;
  io.remove(normalizedSlot);
  return true;
}
